import { ENVIRONMENT } from './env'

const location = window.location
const host = location.host
let CLIENT_ID = host.split('.')[0]
if (CLIENT_ID.includes('localhost')) {
  CLIENT_ID = 'local'
} else if (CLIENT_ID.indexOf('kiwi-release')) {
  CLIENT_ID = 'dev'
}

const config = {
  local: {
    id: 'local',
    port: 8080,
    title: 'Local',
    progressColor: '#ec2123',
    devMode: {
      host: `${location.protocol}//api-release.startkiwi.com`,
      basename: '/local',
      apiRoute: 'local',
    },
    liveMode: {},
    googleAnalytics: {
      globalName: 'Kiwi Local',
      globalId: 'UA-141039591-1',
      clientName: '',
      clientId: '',
    },
  },
  dev: {
    id: 'dev',
    port: 3000,
    title: 'Dev',
    progressColor: '#ec2123',
    devMode: {
      host: `${location.protocol}//api-release.startkiwi.com`,
      basename: '',
      apiRoute: 'dev',
    },
    liveMode: {
      host: `${location.protocol}//api-release.startkiwi.com`,
      basename: '',
      apiRoute: 'dev',
    },
    googleAnalytics: {
      globalName: 'Kiwi Dev',
      globalId: 'UA-141039591-1',
      clientName: '',
      clientId: '',
    },
  },
  mobydick: {
    id: 'mobydick',
    port: 3001,
    title: 'Moby Dick',
    progressColor: '#ec2123',
    devMode: {
      host: `${location.protocol}//api-release.startkiwi.com`,
      basename: '/mobydick',
      apiRoute: 'mobydick',
    },
    liveMode: {
      host: `${location.protocol}//api2.startkiwi.com`,
      basename: '',
      apiRoute: 'mobydick',
    },
    googleAnalytics: {
      globalName: 'MobyDick',
      globalId: 'UA-152054381-1',
      clientName: '',
      clientId: '',
    },
  },
  tazikis: {
    id: 'tazikis',
    port: 8080,
    title: 'Tazikis',
    progressColor: '#ec2123',
    devMode: {
      host: `${location.protocol}//api-release.startkiwi.com`,
      basename: '/tazikis',
      apiRoute: 'tazikis',
    },
    liveMode: {
      host: `${location.protocol}//api2.startkiwi.com`,
      basename: '',
      apiRoute: 'tazikis',
    },
    googleAnalytics: {
      globalName: 'Tazikis',
      globalId: 'UA-152054381-1',
      clientName: '',
      clientId: '',
    },
  },
  tgifridays: {
    id: 'tgifridays',
    port: 8080,
    title: 'TGI Fridays',
    progressColor: '#ec2123',
    devMode: {
      host: `${location.protocol}//api-release.startkiwi.com`,
      basename: '/tgifridays',
      apiRoute: 'tgifridays',
    },
    liveMode: {
      host: `${location.protocol}//api-release.startkiwi.com`,
      basename: '',
      apiRoute: 'tgifridays',
    },

    googleAnalytics: {
      globalName: 'TgiFridays',
      globalId: 'UA-152054381-1',
      clientName: '',
      clientId: '',
    },
  },
  westville: {
    id: 'westville',
    port: 3004,
    title: 'Westville',
    progressColor: '#ec2123',
    devMode: {
      host: `${location.protocol}//api-release.startkiwi.com`,
      basename: '/westville',
      apiRoute: 'dev-westville',
    },
    liveMode: {
      host: `${location.protocol}//18.215.2.178`,
      basename: '',
      apiRoute: 'westville',
    },
    googleAnalytics: {
      globalName: '',
      globalId: '',
      clientName: '',
      clientId: '',
    },
  },
  p66: {
    id: 'p66',
    port: 3005,
    title: 'Phillips 66',
    landingPage: 'learning-plan',
    navigation: false,
    redirectLogout: true,
    progressColor: '#ec2123',
    devMode: {
      host: `${location.protocol}//api-release.startkiwi.com`,
      basename: '/p66',
      apiRoute: 'p66',
    },
    liveMode: {
      host: `${location.protocol}//api-release.startkiwi.com`,
      basename: '/p66',
      apiRoute: 'p66',
    },
    googleAnalytics: {
      globalName: '',
      globalId: '',
      clientName: '',
      clientId: '',
    },
  },
  insomniacookies: {
    id: 'insomnia',
    port: 3006,
    title: 'Insomnia Cookies',
    progressColor: '#ec2123',
    devMode: {
      host: `${location.protocol}//api-release.startkiwi.com`,
      basename: '/insomniacookies',
      apiRoute: 'insomnia',
    },
    liveMode: {
      host: `${location.protocol}//api-release.startkiwi.com`,
      basename: '',
      apiRoute: 'insomnia',
    },

    googleAnalytics: {
      globalName: '',
      globalId: '',
      clientName: '',
      clientId: '',
    },
  },
  epl: {
    id: 'epl',
    port: 3007,
    title: 'El Pollo Loco',
    progressColor: '#ec2123',
    devMode: {
      host: `${location.protocol}//api-release.startkiwi.com`,
      basename: '/epl',
      apiRoute: 'epl',
    },
    liveMode: {
      host: `${location.protocol}//api-release.startkiwi.com`,
      basename: '',
      apiRoute: 'epl',
    },

    googleAnalytics: {
      globalName: '',
      globalId: '',
      clientName: '',
      clientId: '',
    },
  },
  nck: {
    id: 'nck',
    port: 3008,
    title: 'NCK University',
    progressColor: '#ec2123',
    devMode: {
      host: `${location.protocol}//api-release.startkiwi.com`,
      basename: '/nck',
      apiRoute: 'nck',
    },
    liveMode: {
      host: `${location.protocol}//api-release.startkiwi.com`,
      basename: '',
      apiRoute: 'nck',
    },
    googleAnalytics: {
      globalName: '',
      globalId: '',
      clientName: '',
      clientId: '',
    },
  },
  quickfiretx: {
    id: 'quickfiretx',
    port: 3009,
    title: 'QuickFire Restaurants',
    progressColor: '#ec2123',
    devMode: {
      host: `${location.protocol}//api-release.startkiwi.com`,
      basename: '/',
      apiRoute: 'quickfiretx',
    },
    liveMode: {
      host: `${location.protocol}//api-release.startkiwi.com`,
      basename: '',
      apiRoute: 'quickfiretx',
    },
    googleAnalytics: {
      globalName: '',
      globalId: '',
      clientName: '',
      clientId: '',
    },
  },
  mikuni: {
    id: 'mikuni',
    port: 3010,
    title: 'Mikuni',
    progressColor: '#ec2123',
    devMode: {
      host: `${location.protocol}//api-release.startkiwi.com`,
      basename: '/mikuni',
      apiRoute: 'mikuni',
    },
    liveMode: {
      host: `${location.protocol}//api-release.startkiwi.com`,
      basename: '',
      apiRoute: 'mikuni',
    },

    googleAnalytics: {
      globalName: '',
      globalId: '',
      clientName: '',
      clientId: '',
    },
  },
  jimmyjohns: {
    id: 'jimmyjohns',
    port: 3011,
    title: 'Jimmy Johns',
    progressColor: '#ec2123',
    devMode: {
      host: `${location.protocol}//api-release.startkiwi.com`,
      basename: '/jimmyjohns',
      apiRoute: 'jimmyjohns',
    },
    liveMode: {
      host: `${location.protocol}//api-release.startkiwi.com`,
      basename: '',
      apiRoute: 'jimmyjohns',
    },
    googleAnalytics: {
      globalName: '',
      globalId: '',
      clientName: '',
      clientId: '',
    },
  },
  fir: {
    id: 'fir',
    port: 3012,
    title: 'Fir',
    progressColor: '#ec2123',
    devMode: {
      host: `${location.protocol}//api.getfir.com`,
      basename: '/fir',
      apiRoute: 'fir',
    },
    liveMode: {
      host: `${location.protocol}//api.getfir.com`,
      basename: '/fir',
      apiRoute: 'fir',
    },

    googleAnalytics: {
      globalName: '',
      globalId: '',
      clientName: '',
      clientId: '',
    },
  },
  steaknshake: {
    id: 'steaknshake',
    port: 3013,
    title: "Steak 'n Shake",
    progressColor: '#ec2123',
    devMode: {
      host: `${location.protocol}//api-release.startkiwi.com`,
      basename: '/steaknshake',
      apiRoute: 'steaknshake',
    },
    liveMode: {
      host: `${location.protocol}//api-release.startkiwi.com`,
      basename: '',
      apiRoute: 'steaknshake',
    },

    googleAnalytics: {
      globalName: '',
      globalId: '',
      clientName: '',
      clientId: '',
    },
  },
  equinox: {
    id: 'equinox',
    port: 3014,
    title: 'Equinox',
    progressColor: '#ec2123',
    devMode: {
      host: `${location.protocol}//api-release.startkiwi.com`,
      basename: '/equinox',
      apiRoute: 'equinox',
    },
    liveMode: {
      host: `${location.protocol}//api-release.startkiwi.com`,
      basename: '',
      apiRoute: 'equinox',
    },

    googleAnalytics: {
      globalName: '',
      globalId: '',
      clientName: '',
      clientId: '',
    },
  },
  tgifridayscn: {
    id: 'tgifridayscn',
    port: 3015,
    title: 'TGI Fridays China',
    progressColor: '#ec2123',
    devMode: {
      host: `${location.protocol}//api-cn.startkiwi.com`,
      basename: '/tgifridayscn',
      apiRoute: 'tgifridayscn',
    },
    liveMode: {
      host: `${location.protocol}//api-cn.startkiwi.com`,
      basename: '/tgifridayscn',
      apiRoute: 'tgifridayscn',
    },

    googleAnalytics: {
      globalName: '',
      globalId: '',
      clientName: '',
      clientId: '',
    },
  },
  disti: {
    id: 'disti',
    port: 3016,
    title: 'Disti Corporations',
    progressColor: '#ec2123',
    devMode: {
      host: `${location.protocol}//api-release.getfir.com`,
      basename: '/disti',
      apiRoute: 'disti',
    },
    liveMode: {
      host: `${location.protocol}//api.getfir.com`,
      basename: '/disti',
      apiRoute: 'disti',
    },

    googleAnalytics: {
      globalName: '',
      globalId: '',
      clientName: '',
      clientId: '',
    },
  },
  frost: {
    id: 'frost',
    port: 3017,
    title: 'Frost Gelato',
    progressColor: '#3aacf5',
    devMode: {
      host: `${location.protocol}//api-release.startkiwi.com`,
      basename: '/frost',
      apiRoute: 'frost',
    },
    liveMode: {
      host: `${location.protocol}//api-release.startkiwi.com`,
      basename: '',
      apiRoute: 'frost',
    },

    googleAnalytics: {
      globalName: '',
      globalId: '',
      clientName: '',
      clientId: '',
    },
  },
  onlc: {
    id: 'onlc',
    port: 3018,
    title: 'Online Consulting, Inc.',
    progressColor: '#ec2123',
    devMode: {
      host: `${location.protocol}//api-release.getfir.com`,
      basename: '/onlc',
      apiRoute: 'onlc',
    },
    liveMode: {
      host: `${location.protocol}//api.getfir.com`,
      basename: '',
      apiRoute: 'onlc',
    },
    googleAnalytics: {
      globalName: '',
      globalId: '',
      clientName: '',
      clientId: '',
    },
  },
  bento: {
    id: 'bento',
    port: 3020,
    title: 'Bento',
    progressColor: '#3aacf5',
    devMode: {
      host: `${location.protocol}//api-release.startkiwi.com`,
      basename: '/bento',
      apiRoute: 'bento',
    },
    liveMode: {
      host: `${location.protocol}//api-release.startkiwi.com`,
      basename: '',
      apiRoute: 'bento',
    },
    googleAnalytics: {
      globalName: '',
      globalId: '',
      clientName: '',
      clientId: '',
    },
  },
  goldenkrust: {
    id: 'goldenkrust',
    port: 3021,
    title: 'Golden Krust',
    progressColor: '#3aacf5',
    devMode: {
      host: `${location.protocol}//api-release.startkiwi.com`,
      basename: '/goldenkrust',
      apiRoute: 'goldenkrust',
    },
    liveMode: {
      host: `${location.protocol}//api-release.startkiwi.com`,
      basename: '',
      apiRoute: 'goldenkrust',
    },

    googleAnalytics: {
      globalName: '',
      globalId: '',
      clientName: '',
      clientId: '',
    },
  },
  demo: {
    id: 'demo',
    port: 3022,
    title: 'Kiwi Demo',
    progressColor: '#3aacf5',
    devMode: {
      host: `${location.protocol}//api-release.startkiwi.com`,
      basename: '/demo',
      apiRoute: 'demo',
    },
    liveMode: {
      host: `${location.protocol}//api2.startkiwi.com`,
      basename: '',
      apiRoute: 'demo',
    },

    googleAnalytics: {
      globalName: '',
      globalId: '',
      clientName: '',
      clientId: '',
    },
  },
  airforce: {
    id: 'airforce',
    port: 3023,
    title: 'Airforce',
    progressColor: '#13385b',
    devMode: {
      host: `${location.protocol}//api-release.startkiwi.com`,
      basename: '/airforce',
      apiRoute: 'airforce',
    },
    liveMode: {
      host: `${location.protocol}//api-release.startkiwi.com`,
      basename: '',
      apiRoute: 'airforce',
    },
    googleAnalytics: {
      globalName: '',
      globalId: '',
      clientName: '',
      clientId: '',
    },
  },
  mobydickcomm: {
    id: 'mobydickcomm',
    port: 3024,
    title: 'MobyDick Commisary',
    progressColor: '#ec2123',
    devMode: {
      host: `${location.protocol}//api-release.startkiwi.com`,
      basename: '/mobydickcomm',
      apiRoute: 'mobydickcomm',
    },
    liveMode: {
      host: `${location.protocol}//api2.startkiwi.com`,
      basename: '',
      apiRoute: 'mobydickcomm',
    },

    googleAnalytics: {
      globalName: '',
      globalId: '',
      clientName: '',
      clientId: '',
    },
  },
  inkling: {
    id: 'inkling',
    port: 8080,
    title: 'Inkling',
    progressColor: '#009c9e',
    devMode: {
      host: `${location.protocol}//api-release.startkiwi.com`,
      basename: '',
      apiRoute: 'inkling',
    },
    liveMode: {
      host: `${location.protocol}//api-inkling.startkiwi.com`,
      basename: '',
      apiRoute: 'inkling',
    },
    googleAnalytics: {
      globalName: 'Inkling',
      globalId: 'UA-152071245-1',
      clientName: '',
      clientId: '',
    },
  },
  realgoodstuff: {
    id: 'realgoodstuff',
    port: 3026,
    title: 'Inkling',
    progressColor: '#009c9e',

    devMode: {
      host: `${location.protocol}//api-release.startkiwi.com`,
      basename: '/realgoodstuff',
      apiRoute: 'realgoodstuff',
    },

    liveMode: {
      host: `${location.protocol}//api-realgoodstuff.startkiwi.com`,
      basename: '',
      apiRoute: 'realgoodstuff',
    },

    statusColor: {},
    label: {},
    labelColor: {},
    labelIconColor: {},
    displayUsersBy: 1,
    navigation: [
      { name: 'Home', icon: 'home', to: '/dashboard' },
      { name: 'Learning Plan', icon: 'learning-plan', to: '/learning-plan' },
      { name: 'My Library', icon: 'my-library', to: '/library' },
      { name: 'My Report', icon: 'my-report', to: '/report' },
      {
        name: 'Manager Report',
        icon: 'manager-reports',
        to: '/manager-report',
        access: 3,
        second_access: [2, 4],
      },
      { name: 'Discussions', icon: 'discussion', to: '/discussion' },
    ],
    managerReport: {
      courses: true,
      groups: true,
    },
    onlyAdminsCan: {
      markQuizPassed: true,
      markCourseCompleted: true,
    },
    courseManagerAddUser: true,
    hasRedirectUrl: false,
    hasCertificate: true,
    hasGdprMessage: true,
    showPastDueTraining: true,
    defaultQuizRetake: true,
    googleAnalytics: {
      globalName: '',
      globalId: '',
      clientName: '',
      clientId: '',
    },
  },
  juicebar: {
    id: 'juicebar',
    port: 3026,
    title: 'I love juice bar',
    progressColor: '#009c9e',

    devMode: {
      host: `${location.protocol}//api-release.startkiwi.com`,
      basename: '',
      apiRoute: 'juicebar',
    },

    liveMode: {
      host: `${location.protocol}//api2.startkiwi.com`,
      basename: '',
      apiRoute: 'juicebar',
    },

    statusColor: {},
    label: {},
    labelColor: {},
    labelIconColor: {},
    displayUsersBy: 1,
    navigation: [
      { name: 'Home', icon: 'home', to: '/dashboard' },
      { name: 'Learning Plan', icon: 'learning-plan', to: '/learning-plan' },
      { name: 'My Library', icon: 'my-library', to: '/library' },
      { name: 'My Report', icon: 'my-report', to: '/report' },
      {
        name: 'Manager Report',
        icon: 'manager-reports',
        to: '/manager-report',
        access: 3,
        second_access: [2, 4],
      },
      { name: 'Discussions', icon: 'discussion', to: '/discussion' },
    ],
    managerReport: {
      courses: true,
      groups: true,
    },
    onlyAdminsCan: {
      markQuizPassed: true,
      markCourseCompleted: true,
    },
    areaAdminCan: {
      createCourse: true,
      createGroup: true,
    },
    courseManagerAddUser: true,
    hasRedirectUrl: false,
    hasCertificate: true,
    hasGdprMessage: true,
    showPastDueTraining: true,
    defaultQuizRetake: true,
    googleAnalytics: {
      globalName: '',
      globalId: '',
      clientName: '',
      clientId: '',
    },
    hasWelcomeEmail: false,
  },
  realgoodstuff: {
    id: 'realgoodstuff',
    port: 3026,
    title: 'Inkling',
    progressColor: '#009c9e',

    devMode: {
      host: `${location.protocol}//api-release.startkiwi.com`,
      basename: '/realgoodstuff',
      apiRoute: 'realgoodstuff',
    },

    liveMode: {
      host: `${location.protocol}//api-realgoodstuff.startkiwi.com`,
      basename: '',
      apiRoute: 'realgoodstuff',
    },

    googleAnalytics: {
      globalName: '',
      globalId: '',
      clientName: '',
      clientId: '',
    },
  },
  wendys: {
    id: 'wendys',
    port: 3027,
    title: 'Wendys',
    progressColor: '#009c9e',

    devMode: {
      host: `${location.protocol}//api-release.startkiwi.com`,
      basename: '',
      apiRoute: 'wendys',
    },

    liveMode: {
      host: `${location.protocol}//api2.startkiwi.com`,
      basename: '',
      apiRoute: 'wendys',
    },

    googleAnalytics: {
      globalName: 'Wendys',
      globalId: 'UA-152054381-1',
      clientName: '',
      clientId: '',
    },
  },
  hopkinsco: {
    id: 'hopkinsco',
    port: 3029,
    title: 'hopkinsco',
    progressColor: '#ec2123',
    devMode: {
      host: `${location.protocol}//api-release.startkiwi.com`,
      basename: '/hopkinsco',
      apiRoute: 'hopkinsco',
    },
    liveMode: {
      host: `${location.protocol}//api2.startkiwi.com`,
      basename: '',
      apiRoute: 'hopkinsco',
    },
    googleAnalytics: {
      globalName: 'HopkinsCo',
      globalId: 'UA-152054381-1',
      clientName: '',
      clientId: '',
    },
  },
  kitopi: {
    id: 'kitopi',
    port: 3028,
    title: 'Kitopi',
    progressColor: '#80bec7',
    devMode: {
      host: `${location.protocol}//api-release.startkiwi.com`,
      basename: '/kitopi',
      apiRoute: 'kitopi',
    },
    liveMode: {
      host: `${location.protocol}//api2.startkiwi.com`,
      basename: '',
      apiRoute: 'kitopi',
    },
    googleAnalytics: {
      globalName: 'Kitopi',
      globalId: 'UA-152054381-1',
      clientName: '',
      clientId: '',
    },
  },
  zka: {
    id: 'zka',
    port: 3030,
    title: 'Zyra Kombëtare e Auditimit e Kosovës',
    progressColor: '#80bec7',
    devMode: {
      host: `${location.protocol}//api-release.startkiwi.com`,
      basename: '/zka',
      apiRoute: 'zka',
    },
    liveMode: {
      host: `${location.protocol}//api2.startkiwi.com`,
      basename: '',
      apiRoute: 'zka',
    },
    googleAnalytics: {
      globalName: 'Zyra Kombëtare e Auditimit e Kosovës',
      globalId: 'UA-152054381-1',
      clientName: '',
      clientId: '',
    },
  },
  axiawh: {
    id: 'axiawh',
    port: 3031,
    title: "Axia Women's Health",
    progressColor: '#80bec7',
    devMode: {
      host: `${location.protocol}//api-release.startkiwi.com`,
      basename: '/axiawh',
      apiRoute: 'axiawh',
    },
    liveMode: {
      host: `${location.protocol}//api2.startkiwi.com`,
      basename: '',
      apiRoute: 'axiawh',
    },
    googleAnalytics: {
      globalName: "Axia Women's Health",
      globalId: 'UA-152054381-1',
      clientName: '',
      clientId: '',
    },
  },
  flipgenius: {
    id: 'flipgenius',
    port: 3032,
    title: 'Flip Genius Learning',
    progressColor: '#80bec7',
    devMode: {
      host: `${location.protocol}//api-release.startkiwi.com`,
      basename: '/flipgenius',
      apiRoute: 'flipgenius',
    },
    liveMode: {
      host: `${location.protocol}//api2.startkiwi.com`,
      basename: '',
      apiRoute: 'flipgenius',
    },
    googleAnalytics: {
      globalName: 'Flip Genius Learning',
      globalId: 'UA-152054381-1',
      clientName: '',
      clientId: '',
    },
  },
  pritchard: {
    id: 'pritchard',
    port: 3033,
    title: 'Pritchard Industries Inc.',
    progressColor: '#80bec7',
    devMode: {
      host: `${location.protocol}//api-release.startkiwi.com`,
      basename: '/pritchard',
      apiRoute: 'pritchard',
    },
    liveMode: {
      host: `${location.protocol}//api2.startkiwi.com`,
      basename: '',
      apiRoute: 'pritchard',
    },
    googleAnalytics: {
      globalName: 'Pritchard Industries Inc.',
      globalId: 'UA-152054381-1',
      clientName: '',
      clientId: '',
    },
  },
  mcrowd: {
    id: 'mcrowd',
    port: 3034,
    title: 'MCrowd Restaurant group',
    progressColor: '#80bec7',
    devMode: {
      host: `${location.protocol}//api-release.startkiwi.com`,
      basename: '/mcrowd',
      apiRoute: 'mcrowd',
    },
    liveMode: {
      host: `${location.protocol}//api2.startkiwi.com`,
      basename: '',
      apiRoute: 'mcrowd',
    },
    googleAnalytics: {
      globalName: 'MCrowd Restaurant group',
      globalId: 'UA-152054381-1',
      clientName: '',
      clientId: '',
    },
  },
  drg: {
    id: 'drg',
    port: 3035,
    title: 'DRG Concepts Academy',
    progressColor: '#80bec7',
    devMode: {
      host: `${location.protocol}//api-release.startkiwi.com`,
      basename: '/drg',
      apiRoute: 'drg',
    },
    liveMode: {
      host: `${location.protocol}//api2.startkiwi.com`,
      basename: '',
      apiRoute: 'drg',
    },
    googleAnalytics: {
      globalName: 'DRG Concepts Academy',
      globalId: 'UA-152054381-1',
      clientName: '',
      clientId: '',
    },
  },
  sls: {
    id: 'sls',
    port: 3036,
    title: 'Serverless kiwi',
    progressColor: '#80bec7',
    devMode: {
      host: `${location.protocol}//dev-api.kiwilearn.com/`,
      basename: '/sls',
      apiRoute: 'sls',
    },
    liveMode: {
      host: `${location.protocol}//dev-api.kiwilearn.com/`,
      basename: '',
      apiRoute: 'sls',
    },
    googleAnalytics: {
      globalName: 'Serverless kiwi',
      globalId: 'UA-152054381-1',
      clientName: '',
      clientId: '',
    },
  },
  soulfoods: {
    id: 'soulfoods',
    port: 3037,
    title: 'Soulfoods',
    progressColor: '#80bec7',
    devMode: {
      host: `${location.protocol}//api-release.startkiwi.com`,
      basename: '/soulfoods',
      apiRoute: 'soulfoods',
    },
    liveMode: {
      host: `${location.protocol}//api2.startkiwi.com`,
      basename: '',
      apiRoute: 'soulfoods',
    },
    googleAnalytics: {
      globalName: 'SoulFoods',
      globalId: 'UA-152054381-1',
      clientName: '',
      clientId: '',
    },
  },
  opensesame: {
    id: 'opensesame',
    port: 3038,
    title: 'OpenSesame',
    progressColor: '#80bec7',
    devMode: {
      host: `${location.protocol}//api-release.startkiwi.com`,
      basename: '/opensesame',
      apiRoute: 'opensesame',
    },
    liveMode: {
      host: `${location.protocol}//api2.startkiwi.com`,
      basename: '',
      apiRoute: 'opensesame',
    },
    googleAnalytics: {
      globalName: 'OpenSesame',
      globalId: 'UA-152054381-1',
      clientName: '',
      clientId: '',
    },
  },
  wahlburgers: {
    id: 'wahlburgers',
    port: 3038,
    title: 'Wahlburgers',
    progressColor: '#80bec7',
    devMode: {
      host: `${location.protocol}//api-release.startkiwi.com`,
      basename: '/wahlburgers',
      apiRoute: 'wahlburgers',
    },
    liveMode: {
      host: `${location.protocol}//api2.startkiwi.com`,
      basename: '',
      apiRoute: 'wahlburgers',
    },
    googleAnalytics: {
      globalName: 'wahlburgers',
      globalId: 'UA-152054381-1',
      clientName: '',
      clientId: '',
    },
  },
  buli: {
    id: 'buli',
    port: 3029,
    title: 'Buli',
    progressColor: '#80bec7',
    devMode: {
      host: `${location.protocol}//api-release.startkiwi.com`,
      basename: '/buli',
      apiRoute: 'buli',
    },
    liveMode: {
      host: `${location.protocol}//api-release.startkiwi.com`,
      basename: '',
      apiRoute: 'buli',
    },
    googleAnalytics: {
      globalName: 'buli',
      globalId: 'UA-152054381-1',
      clientName: '',
      clientId: '',
    },
  },
  grimaldis: {
    id: 'grimaldis',
    port: 3041,
    title: 'Grimaldis',
    progressColor: '#80bec7',
    devMode: {
      host: `${location.protocol}//api-release.startkiwi.com`,
      basename: '/grimaldis',
      apiRoute: 'grimaldis',
    },
    liveMode: {
      host: `${location.protocol}//api2.startkiwi.com`,
      basename: '',
      apiRoute: 'grimaldis',
    },
    googleAnalytics: {
      globalName: 'grimaldis',
      globalId: 'UA-152054381-1',
      clientName: '',
      clientId: '',
    },
  },
  chickfila: {
    id: 'chickfila',
    port: 3042,
    title: 'Chickfila',
    progressColor: '#80bec7',
    devMode: {
      host: `${location.protocol}//api-release.startkiwi.com`,
      basename: '/chickfila',
      apiRoute: 'chickfila',
    },
    liveMode: {
      host: `${location.protocol}//api2.startkiwi.com`,
      basename: '',
      apiRoute: 'chickfila',
    },
    googleAnalytics: {
      globalName: 'chickfila',
      globalId: 'UA-152054381-1',
      clientName: '',
      clientId: '',
    },
  },
  statefoodsafety: {
    id: 'statefoodsafety',
    port: 3043,
    title: 'statefoodsafety',
    progressColor: '#80bec7',
    devMode: {
      host: `${location.protocol}//api-release.startkiwi.com`,
      basename: '/statefoodsafety',
      apiRoute: 'statefoodsafety',
    },
    liveMode: {
      host: `${location.protocol}//api2.startkiwi.com`,
      basename: '',
      apiRoute: 'statefoodsafety',
    },
    googleAnalytics: {
      globalName: 'statefoodsafety',
      globalId: 'UA-152054381-1',
      clientName: '',
      clientId: '',
    },
  },
  buckandhoneys: {
    id: 'buckandhoneys',
    port: 3044,
    title: 'buckandhoneys',
    progressColor: '#80bec7',
    devMode: {
      host: `${location.protocol}//api-release.startkiwi.com`,
      basename: '/buckandhoneys',
      apiRoute: 'buckandhoneys',
    },
    liveMode: {
      host: `${location.protocol}//api2.startkiwi.com`,
      basename: '',
      apiRoute: 'buckandhoneys',
    },
    googleAnalytics: {
      globalName: 'buckandhoneys',
      globalId: 'UA-152054381-1',
      clientName: '',
      clientId: '',
    },
  },
  charleys: {
    id: 'charleys',
    port: 3044,
    title: 'charleys',
    progressColor: '#80bec7',
    devMode: {
      host: `${location.protocol}//api-release.startkiwi.com`,
      basename: '/charleys',
      apiRoute: 'charleys',
    },
    liveMode: {
      host: `${location.protocol}//api2.startkiwi.com`,
      basename: '',
      apiRoute: 'charleys',
    },
    googleAnalytics: {
      globalName: 'charleys',
      globalId: 'UA-152054381-1',
      clientName: '',
      clientId: '',
    },
  },
}

const url = document.URL
const client = config[CLIENT_ID]

const mode =
  url.indexOf('release.') === -1 &&
    url.indexOf('dev.') === -1 &&
    url.indexOf('localhost') === -1
    ? client.liveMode
    : client.devMode

export default { ...client, ...mode, ...{ ENVIRONMENT: ENVIRONMENT } }